import { Fetch } from '../helpers/fetchWrapper';

const userService = {
  user_url: process.env.REACT_APP_USER_API_URL,

  async updateUser(payload) {
    let res = await Fetch.upload(`${this.user_url}/update-user`, 'PUT', payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updatePassword(payload) {
    let res = await Fetch.patch(`${this.user_url}/update-password`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getToaster() {
    let res = await Fetch.get(`${this.user_url}/get-all-toasters`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default userService;
